import EVENTS from "core/customEvent/events.js";
import INPUT_EVENTS from "./message.js";
import {
  getters,
  state
} from "component/molecules/viewport/toolStates/store.js";
//import getActiveToolsForElement from "component/molecules/viewport/store/getActiveToolsForElement.js";
import getActiveToolsForElement from "component/molecules/viewport/toolStates/getActiveToolsForElement.js";
import getToolsForElement from "component/molecules/viewport/toolStates/getToolsForElement.js";
import getToolsWithDataForElement from "component/molecules/viewport/toolStates/getToolsWithDataForElement.js";
import getToolsWithMoveableHandles from "component/molecules/viewport/toolStates/getToolsWithMoveableHandles.js";
import addNewMeasurement from "./addNewMeasurement";
import { BaseAnnotationTool } from "../../tools/annotation/base/BaseAnnotationTool.js";

import { findHandleDataNearImagePoint } from "component/util/findAndMoveHelpers.js";
import { getEnabledElement } from "component/toolManager/enabledElements.js";
import { getToolState } from "component/toolManager/toolState.js";

import NormalizeMouseEvent from "core/input/mouse";

class ToolEventDispatcher {
  constructor() {
    this.targetElement = null;
    this.activateToolName = "";
    this.activateToolIndex = -1;
    this.elementStub = null;

    this.availableTools = [];
  }
  setElementStub = elementStub => {
    this.elementStub = elementStub;
  };
  setTargetElement = element => {
    this.targetElement = element;
  };

  setupAvailableTools = toolDescriptions => {
    if (typeof toolDescriptions === undefined) {
      return false;
    }

    if (!(toolDescriptions instanceof Array)) {
      return false;
    }

    this.availableTools = toolDescriptions;
  };

  setActivateTool(toolName) {
    if (toolName === "none") {
      this.activateToolName = toolName;
      this.activateToolIndex = -1;
      return false;
    }
    var isExistTool = false;
    var foundToolIdx = -1;
    for (var i = 0; i < this.availableTools.length; i++) {
      if (this.availableTools[i]["name"] === toolName) {
        isExistTool = true;
        foundToolIdx = i;
        break;
      }
    }

    if (isExistTool) {
      this.activateToolName = toolName;
      this.activateToolIndex = foundToolIdx;
    }

    return true;
  }

  activateDispatcher = () => {
    const targetElement = this.targetElement;
    targetElement.addEventListener(EVENTS.MOUSE_CLICK, this.onMouseClick);
    targetElement.addEventListener(EVENTS.MOUSE_DOWN, this.onMouseDown);
    targetElement.addEventListener(
      EVENTS.MOUSE_DOWN_ACTIVATE,
      this.onMouseDownActivate
    );
    targetElement.addEventListener(
      EVENTS.MOUSE_DOUBLE_CLICK,
      this.onMouseDoubleClick
    );
    targetElement.addEventListener(EVENTS.MOUSE_DRAG, this.onMouseDrag);
    targetElement.addEventListener(EVENTS.MOUSE_MOVE, this.onMouseMove);
    targetElement.addEventListener(EVENTS.MOUSE_UP, this.onMouseUp);
    //this.targetElement.addEventListener(EVENTS.MOUSE_WHEEL, mouseWheel);
  };

  deactivateDispatcher = () => {
    const targetElement = this.targetElement;
    targetElement.removeEventListener(EVENTS.MOUSE_CLICK, this.onMouseClick);
    targetElement.removeEventListener(EVENTS.MOUSE_DOWN, this.onMouseDown);
    targetElement.removeEventListener(
      EVENTS.MOUSE_DOWN_ACTIVATE,
      this.onMouseDownActivate
    );
    targetElement.removeEventListener(
      EVENTS.MOUSE_DOUBLE_CLICK,
      this.onMouseDoubleClick
    );
    targetElement.removeEventListener(EVENTS.MOUSE_DRAG, this.onMouseDrag);
    targetElement.removeEventListener(EVENTS.MOUSE_MOVE, this.onMouseMove);
    targetElement.removeEventListener(EVENTS.MOUSE_UP, this.onMouseUp);
    //this.targetElement.removeEventListener(EVENTS.MOUSE_WHEEL, mouseWheel);
  };

  onMouseClick = e => {
    let availableTools = this.availableTools;
    let activateToolIndex = this.activateToolIndex;

    if (typeof availableTools === undefined) {
      return false;
    }

    if (
      typeof availableTools[activateToolIndex] === void 0 ||
      availableTools[activateToolIndex] === undefined
    ) {
      return false;
    }

    let tool = availableTools[activateToolIndex];
    let toolInputEventType = tool["inputType"];

    if (!(toolInputEventType & INPUT_EVENTS.MOUSE_UP)) {
      return false;
    }

    if (!tool.hasOwnProperty("onMouseClick")) {
      return false;
    }

    let callbackFunc = tool["onMouseClick"];

    callbackFunc(e);
  };

  onMouseDown = event => {
    let availableTools = this.availableTools;
    let activateToolIndex = this.activateToolIndex;

    if (typeof availableTools === undefined) {
      return false;
    }

    if (
      typeof availableTools[activateToolIndex] !== void 0 &&
      availableTools[activateToolIndex] !== undefined
    ) {
      let tool = availableTools[activateToolIndex];
      let toolInputEventType = tool["inputType"];

      if (!(toolInputEventType & INPUT_EVENTS.MOUSE_UP)) {
        return false;
      }

      if (tool.hasOwnProperty("onMouseDown")) {
        let callbackFunc = tool["onMouseDown"];

        callbackFunc(event);
        //return false;
      }
    }

    const eventData = event.detail;
    const element = eventData.element;
    const coords = event.detail.currentPoints.canvas;

    /**
     * 1. 현재 활성화된 DCMView에서 사용가능한 도구 목록을 가져옴
     */
    let tools = getToolsForElement(element.element, getters.mouseTools());

    /**
     * 2. 도구 목록중, 마우스 버튼을 이용하는 도구만 필터링
     */

    //tools = tools.filter(tool => Array.isArray(tool.options.mouseButtonMask));
    const firstActiveToolWithCallback = tools.find(
      tool => typeof tool.preMouseDownCallback === "function"
    );

    /**
     * 3. Ghost preMouseDown 제거
     */
    if (firstActiveToolWithCallback) {
      const consumedEvent = firstActiveToolWithCallback.preMouseDownCallback(
        event
      );

      if (consumedEvent) {
        return;
      }
    }

    /**
     * 4. DCMView에 그려진 기록이 있는 Measurement 도구를 가져온다.
     */
    // Annotation tool specific
    const annotationTools = getToolsWithDataForElement(element.element, tools);
    // NEAR HANDLES?
    const annotationToolsWithMoveableHandles = getToolsWithMoveableHandles(
      element.element,
      annotationTools,
      coords,
      "mouse"
    );

    /**
     * 5. 근처에 핸들이 있는지 확인 하여, 핸들이 있으면 핸들을 움직임
     */
    if (annotationToolsWithMoveableHandles.length > 0) {
      const firstToolWithMoveableHandles =
        annotationToolsWithMoveableHandles[0];
      const toolState = getToolState(
        element.element,
        firstToolWithMoveableHandles.name
      );

      const { handle, data } = findHandleDataNearImagePoint(
        element.element,
        toolState,
        firstToolWithMoveableHandles.name,
        coords
      );

      firstToolWithMoveableHandles.handleSelectedCallback(
        event,
        data,
        handle,
        "mouse"
      );
      return;
    }
    /**
     * 5. 근처에 그려진 도구 가 있는지 점검하여, 있으면 그 그려진 도구 인스턴스를 활성화
     */
    const annotationToolsWithPointNearClick = tools.filter(tool => {
      const toolState = getToolState(element.element, tool.name);
      const isNearPoint =
        toolState &&
        toolState.data &&
        tool.pointNearTool &&
        toolState.data.some(data =>
          tool.pointNearTool(element.element, data, coords, "mouse")
        );
      return isNearPoint;
    });

    if (annotationToolsWithPointNearClick.length > 0) {
      const firstToolNearPoint = annotationToolsWithPointNearClick[0];
      const toolState = getToolState(element.element, firstToolNearPoint.name);
      const firstAnnotationNearPoint = toolState.data.find(data =>
        firstToolNearPoint.pointNearTool(element.element, data, coords)
      );

      firstToolNearPoint.toolSelectedCallback(
        event,
        firstAnnotationNearPoint,
        "mouse"
      );
      return;
    }
  };

  onMouseDownActivate = event => {
    ///
    /// 활성화된 Annotation 도구 시작데이터 획득
    ///
    const eventData = event.detail;
    const element = eventData.element;
    let tools = getActiveToolsForElement(element.element, getters.mouseTools());
    tools = tools.filter(
      tool =>
        Array.isArray(tool.options.mouseButtonMask) &&
        tool.options.mouseButtonMask.includes(eventData.buttons) &&
        tool.options.isMouseActive
    );

    if (tools.length > 0) {
      if (tools[0].addNewMeasurement) {
        tools[0].addNewMeasurement(event, "mouse");
      } else if (tools[0] instanceof BaseAnnotationTool) {
        addNewMeasurement(event, tools[0]);
      }
    }
  };

  onMouseDoubleClick = e => {
    let availableTools = this.availableTools;
    let activateToolIndex = this.activateToolIndex;

    if (typeof availableTools === undefined) {
      return false;
    }

    if (
      typeof availableTools[activateToolIndex] === void 0 ||
      availableTools[activateToolIndex] === undefined
    ) {
      return false;
    }

    let tool = availableTools[activateToolIndex];
    let toolInputEventType = tool["inputType"];

    if (!(toolInputEventType & INPUT_EVENTS.MOUSE_UP)) {
      return false;
    }

    if (!tool.hasOwnProperty("onMouseDoubleClick")) {
      return false;
    }

    let callbackFunc = tool["onMouseDoubleClick"];

    callbackFunc(e);
  };

  ///
  /// 현재 활성화된 도구의 (Measurement가 아닌) Drag시 정의한 동작 수행
  ///
  onMouseDrag = e => {
    let availableTools = this.availableTools;
    let activateToolIndex = this.activateToolIndex;

    if (typeof availableTools === undefined) {
      return false;
    }

    // 현재 활성화된 도구가 Measure가 아니더라도,
    // Measure를 조작중이면 기능을 실행하지 않음
    if (state.isToolLocked) {
      return;
    }

    if (
      typeof availableTools[activateToolIndex] !== void 0 &&
      availableTools[activateToolIndex] !== undefined
    ) {
      let tool = availableTools[activateToolIndex];

      const mouseButtonWhich = NormalizeMouseEvent.buttons(e.detail);

      if (mouseButtonWhich !== 1) {
        return false;
      }

      let toolInputEventType = tool["inputType"];

      if (!(toolInputEventType & INPUT_EVENTS.MOUSE_UP)) {
        return false;
      }

      if (!tool.hasOwnProperty("onMouseDrag")) {
        return false;
      }

      let callbackFunc = tool["onMouseDrag"];
      callbackFunc(e);
    }

    ///
    /// 활성화된 Annotation 도구 시작데이터 획득
    ///
    // const eventData = e.detail;
    // const element = eventData.element;
    // let tools = getActiveToolsForElement(element.element, getters.mouseTools());
    // tools = tools.filter(
    //   tool =>
    //     Array.isArray(tool.options.mouseButtonMask) &&
    //     tool.options.mouseButtonMask.includes(eventData.buttons) &&
    //     tool.options.isMouseActive
    // );
    // console.log("MouseDragCallback3");
    // if (tools.length > 0) {
    //   ///
    //   /// 새 Measurement 추가
    //   ///
    //   console.log("MouseDragCallback2");
    //   if (tools[0].mouseDragCallback) {
    //     console.log("MouseDragCallback1");
    //     tools[0].mouseDragCallback(e);
    //   }
    // }
  };

  ///
  /// 마우스를 Measurement 인근에 위치시, Activation 상태 그리기
  ///
  onMouseMove = e => {
    let availableTools = this.availableTools;
    let activateToolIndex = this.activateToolIndex;

    if (typeof availableTools === undefined) {
      return false;
    }



    const { currentPoints } = e.detail;

    // Set the mouse position incase any tool needs it.
    state.mousePositionImage = currentPoints.image;
    //console.log("mousemove");
    ///
    /// 현재 그리고 있는 도구가 있는지 확인
    ///
    const eventData = e.detail;
    const element = eventData.element;
    if (eventData.which !== 1) {
      ///
      /// 활성화된 Annotation 도구 시작데이터 획득
      ///
      let tools = getToolsForElement(element.element, getters.mouseTools());
      let imageNeedsUpdate = false;

      // If any tools are active, check if they have a cursor, and if so update image.
      if (tools.length > 0) {
        imageNeedsUpdate = tools.some(tool => tool.hasCursor);
      }

      // Iterate over each tool, and each tool's data
      // Activate any handles we're hovering over, or whole tools if we're near the tool
      // If we've changed the state of anything, redrawn the image

      for (let t = 0; t < tools.length; t++) {
        const tool = tools[t];

        if (typeof tool.mouseMoveCallback === "function") {
          imageNeedsUpdate = tool.mouseMoveCallback(e) || imageNeedsUpdate;
        }
      }

      tools = getToolsWithDataForElement(element.element, tools);

      // Tool data activation status changed, redraw the image
      if (imageNeedsUpdate === true) {
        let enabledElement = getEnabledElement(element.element);
        enabledElement.needsRedraw = true;
      }
    }
  };

  onMouseUp = e => {
    let availableTools = this.availableTools;
    let activateToolIndex = this.activateToolIndex;

    if (typeof availableTools === undefined) {
      return false;
    }

    if (
      typeof availableTools[activateToolIndex] === void 0 ||
      availableTools[activateToolIndex] === undefined
    ) {
      return false;
    }

    let tool = availableTools[activateToolIndex];
    let toolInputEventType = tool["inputType"];

    if (!(toolInputEventType & INPUT_EVENTS.MOUSE_UP)) {
      return false;
    }

    if (!tool.hasOwnProperty("onMouseUp")) {
      return false;
    }

    let callbackFunc = tool["onMouseUp"];

    callbackFunc(e);
  };
}

export default ToolEventDispatcher;
